export default __webpack_public_path__ + "static/media/benefitsIcon1.bb45b10e.webp";